<div class="detail-header">
  <div class="detail-titles-container">
    @if(!hasTitle){
    <h2 class="title">{{ title }}</h2>
    }
    <ng-content select="[title]"> </ng-content>
  </div>
  <div class="detail-close-container">
    <button type="button" (click)="handleCloseClick($event)" class="close-btn">
      <svg
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</div>

<main class="expansion-content">
  <mat-tab-group #tabs="matTabGroup">
    <mat-tab [label]="dataTitle">
      <ng-content select="[content]"> </ng-content>
    </mat-tab>

    <mat-tab label="Auditoria" [disabled]="!showAudit">
      <daas-consulting-security-audit-detail-page
        #audit
        [entity]="entity"
        [entityId]="entityId"
        class="overflow-y-auto"
      >
      </daas-consulting-security-audit-detail-page>
    </mat-tab>
  </mat-tab-group>
</main>

<!-- Action buttons -->
<div class="detail-footer">
  <ng-content select="[buttons]"> </ng-content>
  @if(! hasButtons ){
  <button type="button" (click)="handleCloseClick($event)" mat-button>
    Volver
  </button>

  @if(showActionPrimary){
  <button
    type="button"
    (click)="handleEditClick($event)"
    mat-flat-button
    color="primary"
  >
    {{ actionPrimaryName }}
  </button>
  } }
</div>
